import { render, staticRenderFns } from "./petrenger.vue?vue&type=template&id=4b2026f5&scoped=true"
import script from "./petrenger.vue?vue&type=script&lang=js"
export * from "./petrenger.vue?vue&type=script&lang=js"
import style0 from "./petrenger.vue?vue&type=style&index=0&id=4b2026f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2026f5",
  null
  
)

export default component.exports